module.exports = __webpack_public_path__ + "static/media/sitting_man_pers.f7d5e0b1.svg";